import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/pencil-icon.svg'


const _hoisted_1 = { class: "text-xl leading-[32px] tracking-[0.01rem] pb-3 text-primary-text-color font-semibold" }
const _hoisted_2 = {
  key: 0,
  class: "w-full list-none flex flex-col items-start gap-3"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "relative text-base text-primary-text-color font-normal leading-5 tracking-[0.01rem]" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "relative text-base text-primary-text-color font-normal leading-5 tracking-[0.01rem]" }
const _hoisted_12 = {
  key: 0,
  class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }
const _hoisted_15 = {
  key: 2,
  class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
}

import { transformSlug } from "@/utils/transformSlug";

import { useTranslate } from "@/composables/useTranslate";

type Props = {
  step: any;
};
type Emits = {
  (
    event: "toggleModalHandler",
    input: any,
    step: any,
    inputIndex?: number,
    groupIndex?: number
  ): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InputFieldsBlock',
  props: {
    step: {}
  },
  emits: ["toggleModalHandler"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const { t } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("phase.input_fields")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.step.inputs.filter((input) => (input.type !== 'image' && input.type !== 'repeatable_group' &&  input.type !== 'group' &&  input.type !== 'document' && input.showInMissingInputs && !input.value) 
      || (input.type === 'repeatable_input' && input.value.some((repValue)=> !repValue.value))), (input) => {
      return (_openBlock(), _createElementBlock("div", {
        key: input.id,
        class: "my-3"
      }, [
        (input.type !== 'repeatable_input')
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              _createElementVNode("li", {
                onClick: ($event: any) => (
            emit(
              'toggleModalHandler',
              input,
              __props.step,
              undefined,
              input.repeatableGroupIndex
            )
          ),
                class: "group hover:cursor-pointer hover:bg-[#F9F8F6] hover:outline hover:outline-[#E3E1EA] p-[3px] hover:rounded-[5px] w-full flex gap-1 items-center outline-1 outline-gray-100 pb-1"
              }, [
                _createElementVNode("p", _hoisted_4, [
                  (input.parentId !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        (__props.step.inputs.find((i) => i.id === input.parentId)?.repeatableGroupDetails)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(transformSlug)(
                    __props.step.inputs.find((i) => i.id === input.parentId)
                      ?.projectReference
                  )
                    ? _unref(transformSlug)(
                        __props.step.inputs.find((i) => i.id === input.parentId)
                          ?.projectReference + ":"
                      )
                    : "") + " " + _toDisplayString(__props.step.inputs
                    .find((i) => i.id === input.parentId)
                    ?.repeatableGroupDetails.find(
                      (item) =>
                        item.order === input.repeatableGroupIndex + 1
                    )?.name) + " / ", 1))
                          : (__props.step.inputs.find((i) => i.id === input.parentId)?.repeatableInputNoun)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.step.inputs.find((i) => i.id === input.parentId)
                    ?.repeatableInputNoun + ` ${input.repeatableGroupIndex + 1}`) + " / ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.step.inputs.find((i) => i.id === input.parentId)?.name) + " /", 1))
                      ]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(input.name), 1)
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("img", {
                  class: "w-3 h-3 invisible group-hover:visible ml-auto",
                  src: _imports_0,
                  alt: "Icon"
                }, null, -1))
              ], 8, _hoisted_3)
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.value.filter((item)=> !item.value), (repeatableInput) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: repeatableInput.index,
                  onClick: ($event: any) => (
            emit(
              'toggleModalHandler',
              input,
              __props.step,
              repeatableInput.index,
              input.repeatableGroupIndex
            )
          ),
                  class: "group hover:cursor-pointer hover:bg-[#F9F8F6] hover:outline hover:outline-[#E3E1EA] p-[3px] hover:rounded-[5px] w-full flex gap-1 items-center outline-1 outline-gray-100 pb-1"
                }, [
                  _createElementVNode("p", _hoisted_11, [
                    (input.isConditionallyRepetable)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(input.name + ` ${repeatableInput.index + 1}`), 1))
                      : (input.repeatableInputNoun)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(input.name) + " / ", 1),
                            _createTextVNode(" " + _toDisplayString(input.repeatableInputNoun + ` ${repeatableInput.index + 1}`), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(input.name), 1))
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    class: "w-3 h-3 invisible group-hover:visible ml-auto",
                    src: _imports_0,
                    alt: "Icon"
                  }, null, -1))
                ], 8, _hoisted_10))
              }), 128))
            ]))
      ]))
    }), 128))
  ]))
}
}

})